module.exports = __webpack_public_path__ + "img/stock.f76fef17.png";